export function planningTimeRange(hours, halbtag) {
  if (Number(hours) >= 6) return { start: "080000", end: "170000" };
  if (halbtag === "Nachmittag") return { start: "130000", end: "170000" };
  return { start: "080000", end: "120000" };
}

export function escapeIcs(value) {
  return String(value ?? "")
    .replace(/\\/g, "\\\\")
    .replace(/\r?\n/g, "\\n")
    .replace(/([,;])/g, "\\$1");
}

export function planningEntryIcs({ entry, employeeName, mandateName, now = new Date() }) {
  const day = String(entry.datum).replaceAll("-", "");
  const stamp = now.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
  const { start, end } = planningTimeRange(entry.stunden, entry.halbtag);
  const identity = String(entry.id || `${entry.mitarbeiterId}-${entry.mandatId}-${day}`)
    .replace(/[^a-zA-Z0-9.-]/g, "-");
  const location = entry.inhouseExtern === "Extern" ? "extern" : "inhouse";
  const summary = `${mandateName} – ${employeeName}`;
  const description = [
    `Planungseintrag aus Abelia Planung: ${mandateName}`,
    `${entry.stunden}h`,
    employeeName,
    entry.phaseName || entry.phaseId,
    entry.kommentar
  ].filter(Boolean).join(", ");
  const content = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Abelia Planung//DE", "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT", `UID:abelia-${identity}@abelia-beratung.ch`, `DTSTAMP:${stamp}`,
    `DTSTART:${day}T${start}`, `DTEND:${day}T${end}`, `SUMMARY:${escapeIcs(summary)}`,
    `LOCATION:${location}`, `DESCRIPTION:${escapeIcs(description)}`, "END:VEVENT", "END:VCALENDAR", ""
  ].join("\r\n");
  const safeMandate = mandateName.replace(/[^a-zA-Z0-9À-ɏ]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 30) || "Planung";
  return { content, filename: `Termin_${day}_${safeMandate}.ics` };
}

export function downloadPlanningEntryIcs(details) {
  const { content, filename } = planningEntryIcs(details);
  const url = URL.createObjectURL(new Blob([content], { type: "text/calendar;charset=utf-8" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
